<script>
import VueBarcode from 'vue-barcode';
import CurrencyInput from '../components/CurrencyInput.vue'
import LabelValueComponent from '../components/LabelValueComponent.vue';

export default {
  data: () => ({
    dialog: false,
    dialogTyC: false,
    tycAccept: false,
    snackbar: {
      color: "success",
      icon: "mdi-check-circle",
      mode: "multi-line",
      timeout: 1000,
      title: "Copiado!",
      text: "Referencia copiada al portapapeles.",
      visible: false
    },
    currencyOpts: {
      "currency": "MXN",
      "currencyDisplay": "hidden",
      "valueRange": {
        "min": 0,
        "max": 0,
      },
      "precision": 2,
      "hideCurrencySymbolOnFocus": false,
      "hideGroupingSeparatorOnFocus": false,
      "hideNegligibleDecimalDigitsOnFocus": false,
      "autoDecimalDigits": false,
      "useGrouping": false,
      "accountingSign": false
    },
    banking_agreement: "002258382",
    other_banks: "012914002022583823",
    bank_selection: "BBVA",
    enrollment: "",
    fullname: "",
    period_desc: "",
    period: "",
    campus_code: "",
    campus_desc: "",
    payment_type: "",
    payment_desc: "",
    due_date: new Date().toJSON().slice(0, 10).split("-").reverse().join("-"),
    amount: null,
    previousPrice: null,
    reference: "1234567890987654",
    deviceWidth: window.innerWidth,
    deviceHeight: window.innerHeight,
  }),
  mounted() {
    this.setQueryStringDefaults();
    // this.getReference();
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });
  },
  methods: {
    onResize() {
      this.deviceWidth = window.innerWidth;
      this.deviceHeight = window.innerHeight;
    },
    setQueryStringDefaults() {
      let queryString = window.location.search;
      let urlParams = new URLSearchParams(queryString);

      if (urlParams.has('fullname')) {
        this.fullname = urlParams.get('fullname');
      }
      if (urlParams.has('enrollment')) {
        this.enrollment = urlParams.get('enrollment');
      }
      if (urlParams.has('campus_code')) {
        this.campus_code = urlParams.get('campus_code');
      }
      if (urlParams.has('campus_desc')) {
        this.campus_desc = urlParams.get('campus_desc');
      }
      if (urlParams.has('amount')) {
        this.amount = parseFloat(urlParams.get('amount'));
        this.currencyOpts.valueRange.max = this.amount
      }
      if (urlParams.has('period')) {
        this.period = urlParams.get('period');
      }
      if (urlParams.has('period_desc')) {
        this.period_desc = urlParams.get('period_desc');
      }
      if (urlParams.has('due_date') && urlParams.get('due_date') !== '') {
        this.due_date = this.convertDateToformat(urlParams.get('due_date'))
      }
      if (urlParams.has('payment_type')) {
        this.payment_type = urlParams.get('payment_type');
        this.payment_desc = this.getPaymentDescription()
      }
    },
    getPaymentDescription() {
      let map = {
        'C': "Colegiatura",
        'K': "Derechos de Titulación",
        'D': "Diversos Servicios",
      }
      return map[this.$data.payment_type]
    },
    getReference() {
      if (this.currencyOpts.valueRange.min >= this.amount <= this.currencyOpts.valueRange.max) {
        console.debug("calculando referencia ");
        this.axios.get("/reference/refresh",
          {
            params: {
              enrollment: this.enrollment,
              campusCode: this.campus_code,
              period: this.period,
              paymentType: this.payment_type,
              amount: this.amount,
              dueDate: this.due_date
            }
          })
          .then((response) => {
            this.reference = response.data
          })
          .catch((error) => {
            console.error("error", error);
          })
      }
    },
    handleAmount() {
      let stringValue = this.amount.toString()
      let regex = /^\d*(\.\d{1,2})?$/
      if (!stringValue.match(regex) && this.amount !== 0) {
        this.amount = this.previousPrice
      }
      this.previousPrice = this.amount
      this.getReference()
    },
    copy(e) {
      let spei_number = e === 'convenio' ? this.getConvenio() : this.reference
      let notifyText = this.bank_selection === "BBVA" ? "Convenio copiado" : "Cuenta CLABE copiada"
      notifyText = e === 'convenio' ? "Convenio copiado" : "Cuenta CLABE copiada"

      navigator.clipboard.writeText(spei_number)
      this.snackbar.text = notifyText
      this.snackbar.visible = true;
    },
    getConvenio() {
      let spei_number = this.bank_selection === "BBVA" ? this.banking_agreement : this.other_banks
      return spei_number
    },
    convertDateToformat(strDate) {
      if (strDate.length !== 8) {
        throw new Error("La cadena debe tener exactamente 8 dígitos en formato ddmmyyyy");
      }
      const dia = strDate.slice(0, 2);
      const mes = strDate.slice(2, 4);
      const anio = strDate.slice(4, 8);
      return `${dia}-${mes}-${anio}`;
    },
    convertDateToLetter(strDate) {
      const [dia, mes, anio] = strDate.split("-").map(Number);
      const fecha = new Date(anio, mes - 1, dia); // Mes es 0-based
      const dateFormated = new Intl.DateTimeFormat("es-ES", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
      return dateFormated.format(fecha);
    },
  },
  components: {
    "barcode": VueBarcode,
    CurrencyInput,
    LabelValueComponent,
  },
  filters: {
    convertDateToLetter(strDate) {
      let regexDateFormat = /^\d{2}-\d{2}-\d{4}$/
      if (regexDateFormat) {
        const [dia, mes, anio] = strDate.split("-").map(Number);
        const fecha = new Date(anio, mes - 1, dia); // Mes es 0-based
        const dateFormated = new Intl.DateTimeFormat("es-ES", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        });
        return dateFormated.format(fecha);
      } else {
        throw Error("Solo se aceptan fechas del formato dd-MM-yyyy")
      }
    }
  }
}
</script>

<template>
  <div>
    <div class="mt-10" variant="outlined">
      <v-card-text class="py-0" color="text-red">
        <LabelValueComponent label="Matricula" :value="enrollment" />
        <LabelValueComponent label="Nombre" :value="fullname" />
        <LabelValueComponent label="Periodo" :value="period_desc" />
        <LabelValueComponent label="Campus" :value="campus_desc" />
        <LabelValueComponent label="Concepto" :value="payment_desc" />
        <v-row>
          <v-col align="right" class="text-h5 text-md-right text-center black--text font-weight-bold" col="2" sm="12"
            xs="12" md="6">
            MONTO:
          </v-col>

          <v-col col="6" md="6" sm="12" xs="12"
            class="text-h5 text-lg-left text-md-center text-sm-center black--text py-sm-2 py-xs-2">
            <v-icon>
              mdi-currency-usd
            </v-icon>
            <CurrencyInput class="currencyInput" v-model="amount" :options="currencyOpts" @input="handleAmount" />
          </v-col>
        </v-row>
        <LabelValueComponent label="Vigencia de Referencia" :value="due_date | convertDateToLetter" />
        <v-row justify="center" class="ml-12">
          <v-checkbox class="ma-1 pa-1 mt-3" hide-details="true" v-model="tycAccept">
            <template v-slot:label>
              <p class="text-h6 px-0 mt-4">Acepto políticas, términos y condiciones.</p>
            </template>
          </v-checkbox>
        </v-row>
        <div v-if="tycAccept">
          <v-row justify="center" class="mb-4">
            <v-col cols="11" md="8" lg="7">
              <div class="payment-disclaimer">
                <v-icon class="payment-disclaimer__icon">
                  mdi-alert
                </v-icon>
                <p class="payment-disclaimer__text mb-0">
                  <strong>Importante:</strong> La referencia de pago se genera con base en el monto capturado. Si
                  realizas el pago por una cantidad diferente, la operación será rechazada automáticamente.
                </p>
              </div>
            </v-col>
          </v-row>
          <!-- Selección de banco -->
          <v-row>
            <v-col col="3" align="right">
              <v-row class="float-end pt-6">
                <v-radio-group v-model="bank_selection" row class="py-sm-2 py-xs-2 mt-16">
                  <v-radio value="BBVA" class="px-12 mx-12" style="font-size: 19px;">
                    <template v-slot:label>
                      <div class="d-inline">
                        <v-img :width="200" src="../assets/BBVA.svg"></v-img>
                      </div>
                    </template>
                  </v-radio>
                </v-radio-group>
              </v-row>
            </v-col>
            <v-col col="3">
              <v-radio-group v-model="bank_selection" row class="py-sm-2 py-xs-2">
                <v-radio value="otherBank" class="px-12 mx-12" justify="center">
                  <template v-slot:label>
                    <v-col cols="12">
                      <v-card outlined color="transparent">
                        <v-icon size="150" color="black" class="pl-4">
                          mdi-bank
                        </v-icon>
                        <v-card-title class="text-h6 pa-0">
                          OTROS BANCOS
                        </v-card-title>
                      </v-card>
                    </v-col>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-col>
          </v-row>

          <!-- Datos BBVA -->
          <div v-if='bank_selection === "BBVA"'>
            <v-row justify="center" class="mb-6" align="center">
              <v-col class="d-flex text-h5 black--text font-weight-medium" col="4" md="3" sm="10" xs="10">
                CONVENIO : {{ banking_agreement }}
                <v-btn class="" plain @click="copy('convenio')" min-width="auto">
                  <v-icon color="#000">
                    mdi-content-copy
                  </v-icon>
                </v-btn>
              </v-col>
              <v-col class="d-flex justify-center" col="3" md="3" sm="10" xs="10">
                <v-card outlined color="transparent" class="bbva-guide-card">
                  <a href="https://documentacionebc.s3.amazonaws.com/qa/Instructivos_Transferencia_BBVA.pdf"
                    target="_blank" class="bbva-guide-link">
                    <v-img :width="90" cover src="../assets/descargar-pdf.png"></v-img>
                    <div class="bbva-guide-title">
                      <span>GUÍA PAGO</span>
                      <span>BBVA</span>
                    </div>
                  </a>
                </v-card>

              </v-col>
            </v-row>
            <v-row justify="center" class="mb-6">
              <v-col class="d-flex black--text font-weight-medium text-h6 text-lg-h5" col="4" md="5" sm="8" xs="8">
                REFERENCIA COMPLETA:
                {{ reference }}
                <v-btn plain @click="copy('reference')">
                  <v-icon color="#000">
                    mdi-content-copy
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row justify="center" class="mb-6">
              <div class="d-flex" col="12" style="width: 600px!important;">
                <barcode class="mx-auto" v-bind:value="reference" :width='deviceWidth < 600 ? 1.3 : 2'
                  :options="{ lineColor: '#0275d8', text: 'Scan' }">
                </barcode>
              </div>

            </v-row>
            <v-row align="center" justify="center" class="ml-12">
              <v-col class="d-flex justify-center col-10 col-lg-6">
                <p class="font-weight-regular text-h6 my-2 text-center">
                  <strong class="text-h5 font-weight-bold">NOTA: </strong> Los pagos se registrarán en intranet el día
                  hábil
                  siguiente a la fecha de pago. Para tu tranquilidad, si has realizado tu pago en la fecha límite y aún
                  no
                  lo ves reflejado en la plataforma, no se generarán recargos por mora, siempre que el pago se haya
                  realizado en tiempo y forma.
                </p>
              </v-col>
            </v-row>
          </div>

          <!-- Datos SPEI -->
          <div v-if='bank_selection !== "BBVA"'>
            <v-row>
              <v-col class="d-flex text-h5 black--text font-weight-bold justify-center justify-lg-end" col="5" sm="10"
                md="5">
                CUENTA CLABE : {{ other_banks }}
                <v-btn class="mx-0 px-0" plain @click="copy('convenio')">
                  <v-icon color="#000">
                    mdi-content-copy
                  </v-icon>
                </v-btn>
              </v-col>
              <v-col class="d-flex text-h6 text-lg-h5 black--text font-weight-bold justify-md-center" col="5" sm="10"
                md="5">
                CONCEPTO SPEI:
                {{ reference }}
                <v-btn plain @click="copy('reference')">
                  <v-icon color="#000">
                    mdi-content-copy
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="d-flex justify-lg-end justify-center" col="4" sm="12" md="4" xs="12">
                <qr-code v-bind:text="other_banks"></qr-code>
              </v-col>
              <!-- Fila para el PDF -->
              <v-col cols="4" sm="12" md="4" class="py-12" align="center">
                <v-card outlined color="transparent">
                  <a href="https://documentacionebc.s3.amazonaws.com/qa/Instructivos_interbancario.pdf" target="_blank">
                    <v-img :width="90" cover src="../assets/descargar-pdf.png"></v-img>
                  </a>
                  <v-card-title class="text-h5 font-weight-bold justify-center">
                    GUÍA PAGO OTROS BANCOS
                  </v-card-title>
                </v-card>
              </v-col>

              <v-col class="d-flex justify-lg-start justify-center" col="4" sm="12" md="4" xs="12">
                <qr-code v-bind:text="reference"></qr-code>
              </v-col>
            </v-row>
            <v-row align="center" justify="center" class="ml-12">
              <v-col class="d-flex justify-center col-10 col-lg-6">
                <p class="font-weight-regular text-h6 my-2 pt-2">
                  <strong class="text-h5 font-weight-bold">NOTA1: </strong> Los pagos se registrarán en intranet el día
                  hábil
                  siguiente a la fecha de pago. Para tu tranquilidad, si has realizado tu pago en la fecha límite y aún
                  no
                  lo ves reflejado en la plataforma, no se generarán recargos por mora, siempre que el pago se haya
                  realizado en tiempo y forma.<br>
                </p>
              </v-col>
            </v-row>
            <v-row align="center" justify="center" class="ml-12">
              <v-col class="d-flex justify-center col-10 col-lg-6">
                <p class="font-weight-regular text-h6 my-3">
                  <strong class="text-h5 font-weight-bold">NOTA2: </strong> En caso de realizar una transferencia o SPEI
                  interbancario,
                  favor de verificar dentro de las 24 horas siguientes al pago, que el banco no haya devuelto tu
                  Transferencia.
                </p>
              </v-col>
            </v-row>
          </div>

        </div>

        <v-row justify="center" class="mx-12 my-12">
          <button class="buttonTyC primary--text font-weight-bold text-h6" style="text-transform: unset !important;"
            @click="dialog = true">
            Consultar políticas, términos y condiciones.
          </button>
        </v-row>
      </v-card-text>
    </div>
    <!-- Notify -->
    <v-snackbar v-model="snackbar.visible" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'"
      :timeout="snackbar.timeout" :top="snackbar.position === 'top'">
      <v-layout align-center pr-4>
        <v-icon class="pr-3" dark large>{{ snackbar.icon }}</v-icon>
        <v-layout column>
          <div>
            <strong>{{ snackbar.title }}</strong>
          </div>
          <div>{{ snackbar.text }}</div>
        </v-layout>
      </v-layout>
      <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>

    <!-- EL Modal -->
    <div class="text-center">
      <v-dialog v-model="dialog" activator="parent" width="auto" persistent>
        <v-card>
          <v-card-text class="text-h7 font-weight-bold">
            <div align="center" class="justify-center text-h5 font-weight-bold">Términos y Condiciones.</div> <br>
            Los presentes términos y condiciones forman parte integral de los contratos actualmente vigentes entre
            Escuela
            Bancaria y Comercial, S.C. (en adelante referida como "EBC") y los alumnos, ya sean personas físicas o
            morales
            (en adelante referido como "EL CLIENTE"), que expresen su conformidad con los presentes. Queda entendido que
            el término "los contratos" relaciona todos aquellos productos y servicios celebrados y contratados entre la
            EBC y EL CLIENTE.<br>

            PRIMERA: OBJETO: "Pagos por Internet" es un servicio ofrecido por EBC a sus clientes a través de su sistema
            de
            pagos electrónicos, al cual deberá accederse vía Internet, con el fin de darle AL CLIENTE información o
            consulta y permitirle la realización de operaciones bancarias determinadas o habilitadas por SU BANCO a sus
            clientes. <br>

            SEGUNDA: SERVICIOS: Las operaciones a realizar serían las vigentes a la fecha en nuestro módulo de "Pagos
            por
            Internet" y aquellas que se implementen en el futuro. <br>

            TERCERA: ACCESO AL SERVICIO: Para poder acceder al servicio "Pagos por Internet", EL CLIENTE deberá disponer
            de los medios físicos necesarios que le permitan recibir o transmitir por vía Internet la información
            relacionada con los productos y servicios de EBC. EL CLIENTE mantendrá a su propio costo y gasto el equipo y
            los servicios de comunicación necesarios para utilizar el servicio y EBC no se haría responsable de la
            disponibilidad, ni de la confiabilidad de dicho equipo o de los servicios de comunicación utilizados por EL
            CLIENTE. EBC pondrá en conocimiento de EL CLIENTE la dirección en Internet, a fin de que EL CLIENTE pueda
            realizar las operaciones bancarias determinadas o habilitadas. <br>

            CUARTA: CLAVE DE ACCESO Y CLAVE PARA OPERACIONES: Para acceder a "Pagos por Internet", EL CLIENTE contaría
            con
            una clave de acceso que podrá ser activada por EL CLIENTE a través de un mecanismo de registro de clave
            definido por EBC. La clave de acceso y operaciones constituirán la firma electrónica que identificaría a EL
            CLIENTE en sus relaciones con EBC vía Internet, y estarían bajo su control exclusivo. Por tanto, sería
            absoluta responsabilidad de EL CLIENTE el nivel de seguridad con el que maneje su clave de acceso y su clave
            para operaciones. Adicionalmente, EL CLIENTE asumirá todos los riesgos, costos y pérdidas incurridas que
            tengan origen o que estén relacionados con el uso no autorizado de los servicios por personas que obtengan
            acceso bajo su responsabilidad. Cualquier operación realizada por EL CLIENTE con la utilización de su clave
            será entendida como válida, legítima y auténticamente por éste, sin que EBC tenga la obligación de realizar
            o
            tomar resguardo adicional en tal sentido. No podrá oponerse defensa alguna basada en defecto de acreditación
            asumiendo EL CLIENTE toda la consecuencia jurídica del uso del sistema en su nombre. <br>

            QUINTA: TARIFA DEL SERVICIO: La utilización de cualquiera de los servicios prestados por EBC a través de
            "Pagos por Internet" no tendrá un costo para EL CLIENTE, los costos asumidos por el cliente son los
            determinados por EL BANCO por el cual realice la transacción, el cual éste acepta expresamente. <br>

            SEXTA: OBLIGACIONES DEL CLIENTE: Además de las obligaciones contenidas en los contratos con, o a través de
            EBC, EL CLIENTE también se obliga a:<br>
            1) Establecer los controles necesarios para que terceras personas no autorizadas operen el servicio.<br>
            2) No permitir que terceros conozcan sus claves de acceso al servicio y de operaciones.<br>

            SÉPTIMA: EXONERACIÓN DE RESPONSABILIDADES DE EBC: EBC no sería responsable en los siguientes eventos:<br>
            1) EBC no se responsabiliza por el uso indebido del servicio "Pagos por Internet" por parte de las personas
            autorizadas o no, por EL CLIENTE, para operar el servicio. En consecuencia EL CLIENTE asume toda la
            responsabilidad de las operaciones ordenadas mediante el servicio de acceso en línea empleando su clave de
            acceso y clave para operaciones. Para el efecto, EL CLIENTE acepta desde ahora y como efecto de las
            operaciones y/o transacciones efectuadas, los registros magnéticos que se originen.<br>
            2) EBC no se responsabiliza de los perjuicios de cualquier naturaleza que pueda sufrir EL CLIENTE como
            consecuencia de una imposibilidad, demora o deficiente transmisión de los datos u operaciones solicitadas en
            su computador, a causa de fallas de comunicación, fallas en el equipo utilizado por EL CLIENTE o fallas
            técnicas ajenas al control de EBC. Tampoco será responsable en los eventos de fuerza mayor, caso fortuito o
            causa extraña que en un algún momento puedan ocasionar perjuicios al equipo o medio físico utilizado por EL
            CLIENTE para comunicarse con el sistema que utiliza EBC.<br>
            3) EBC no se responsabiliza en caso de que las operaciones no puedan realizarse por causas atribuidas a EL
            CLIENTE, tales como cuentas embargadas, insuficiencia de fondos en sus cuentas o por incorrecta operación
            del
            sistema o por daños en los sistemas de comunicación, u otros que estén por fuera del control de EBC.<br>

            OCTAVA: MODIFICACIONES: EBC se reserva el derecho, a su entera discreción, de modificar o sustituir
            cualquiera
            de estos Términos y Condiciones o bien, cambiar, suspender o interrumpir el servicio de Pagos por Internet
            (incluyendo sin limitación la disponibilidad de cualquier característica) en cualquier momento, notificando
            a
            EL CLIENTE por cualquier medio físico y/o tecnológico. EBC también podrá imponer límites a características y
            servicios determinados o restringir su acceso a la totalidad o parte de los Pagos por Internet sin realizar
            ningún aviso ni asumir ninguna responsabilidad. La modificación y/o adición de los Términos y Condiciones
            formará parte integral de los mismos, en el entendido de que el uso de el Pago por Internet constituirá la
            aceptación de dichas modificaciones a los Términos y Condiciones por parte de EL CLIENTE. EL CLIENTE al
            ingresar a realizar Pago por Internet acepta expresamente los términos y condiciones aquí contenidos, así
            como
            sus modificaciones. <br>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" block @click="dialog = false">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <!-- Modal para el PDF -->

    <div class="text-center">
      <v-dialog v-model="dialogTyC" activator="parent" height="80%" persistent>
        <v-card height="80%">
          <v-card-text class="text-h7 font-weight-bold text-center">
            <iframe src="https://documentacionebc.s3.amazonaws.com/qa/Diptico+CIE.pdf#navpanes=0" width="100%"
              :height="deviceHeight * .65" text-center></iframe>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-row>
              <v-col>
                <v-btn color="primary" block @click="dialogTyC = false; tycAccept = false">Cerrar</v-btn>
              </v-col>
              <v-col>
                <v-btn color="success" block @click="dialogTyC = false; tycAccept = true">Aceptar</v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>


  </div>
</template>


<style lang="scss">
.currencyInput {
  min-width: 50px;
  max-width: 120px;
}

.v-btn {
  max-width: 90%;
}

.buttonTyC {
  border: 3px solid;
  border-radius: 5px;
  padding: 5px 10px;
}

.bbva-guide-card {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-width: 220px;
  max-width: 240px;
}

.bbva-guide-link {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  color: inherit;
  width: 100%;
}

.bbva-guide-title {
  color: #000;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  line-height: 1.05;
  width: 100%;
  padding-top: 10px;
  font-weight: 700;
}

.bbva-guide-title span:first-child {
  font-size: 2rem;
}

.bbva-guide-title span:last-child {
  font-size: 2.25rem;
}

.payment-disclaimer {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  background: #fffdf8;
  border: 1px solid #efe4c8;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  padding: 12px 16px;
}

.payment-disclaimer__icon {
  color: #b08a3b;
  margin-top: 1px;
  font-size: 20px;
}

.payment-disclaimer__text {
  color: #3a3324;
  font-size: 1.15rem;
  font-weight: 500;
  line-height: 1.35;
}
</style>
